<template>
    <Card :bordered="false" class="border-radius-0" :class="{'ant-card-body-p-0': isChildren }">
        <CTable
                :isLoading="isLoading"
                v-model:columns="data.columns"
                v-model:page="data.page"
                :options="data.tableOptions"
                :manages="data.manages"
                :manageExtras="data.manageExtras"
                :rowActions="data.rowActions"
                :clientSide="true"
                :canRefresh="!isChildren"
                :visibleSearch="visibleSearch"
                @search="(search) => onSearch({ props, ...search })"
        ></CTable>
    </Card>
</template>

<script>
import { defineComponent, defineAsyncComponent, reactive } from "vue";
import { isLoading, initState, state, onSearch, initData } from "./sampling-product.logic";
import { Card } from "ant-design-vue";
import { state as stateApp } from "../../../../app.logic";
import { useRoute } from "vue-router";

export default defineComponent({
    components: {
        Card,
        CTable: defineAsyncComponent(() => import("../../../../components/table/CTable")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        viewOnly: {},
        useForm: {},
        parent: {},
        fetchCriteria: {},
        visibleSearch: { default: true },
        isChildren: { default: false },
        columnTemplate: { default: 'template1' },
        isRepeat: { default: false },
        refSamplingRequestTypeKey: { default: [] },
    },
    setup(props) {
        const route = useRoute();
        const isNotVisibleCreate = route?.query?.isNotVisibleCreate == 'true' ? true: false;
        const setupData = { props, isLoading, onSearch };
        if (!props.isChildren) {
            initState({ props, isNotVisibleCreate });
            setupData.data = state;
            setupData.onSearch = onSearch;
        } else {
            const data = reactive({});
            const refs = reactive({});
            initData({ props, data, refs, isNotVisibleCreate });
            setupData.data = data;
            setupData.refs = refs;
            setupData.onSearch = () => {};
        }
        return setupData
    },
});
</script>